import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { signInWithEmailHelper, auth, db } from './firebaseConfig';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [showRestricted, setShowRestricted] = useState(false);

  const goHome = () => {
    try {
      if (Platform.OS === 'web') {
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new Event('app:navigate'));
      }
    } catch {}
  };

  const onSignIn = async () => {
    if (!email || !password) {
      setStatus('Enter email and password');
      return;
    }
    try {
      setLoading(true);
      setStatus('Signing in...');
      const user = await signInWithEmailHelper(email.trim(), password);
      setStatus('Checking permissions...');
      let done = false;
      const ref = doc(db, 'users', user.uid);
      // Real-time check to avoid stale reads right after sign-in
      const unsub = onSnapshot(ref, (snap) => {
        if (done) return;
        const isAdmin = !!(snap.exists() && snap.data().userType === 'admin');
        if (isAdmin) {
          setStatus('');
          done = true;
          unsub();
          try {
            if (Platform.OS === 'web') {
              window.history.pushState({}, '', '/admin');
              window.dispatchEvent(new Event('app:navigate'));
            }
          } catch {}
        } else {
          setShowRestricted(true);
          setStatus('Restricted. Admins only.');
          done = true;
          unsub();
        }
      }, (err) => {
        setShowRestricted(true);
        setStatus('Restricted. Admins only.');
      });
    } catch (e) {
      const code = e?.code || '';
      let msg = 'Sign-in failed';
      if (code.includes('invalid-email')) msg = 'Invalid email format';
      else if (code.includes('user-not-found')) msg = 'No account found for this email';
      else if (code.includes('wrong-password') || code.includes('invalid-credential')) msg = 'Incorrect email or password';
      else if (code.includes('too-many-requests')) msg = 'Too many attempts. Try again later';
      else if (code.includes('network-request-failed')) msg = 'Network error. Check your connection';
      setStatus(msg);
    } finally {
      setLoading(false);
    }
  };

  if (showRestricted) {
    return (
      <View style={styles.restrictedWrap}>
        <Text style={styles.restrictedText}>Restricted. Admins only.</Text>
        <TouchableOpacity style={styles.homeBtn} onPress={goHome}>
          <Text style={styles.homeBtnText}>Go Home</Text>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Admin Login</Text>
      <View style={styles.field}>
        <TextInput
          placeholder="Email"
          placeholderTextColor="rgba(255,255,255,0.5)"
          autoCapitalize="none"
          keyboardType="email-address"
          style={styles.input}
          value={email}
          onChangeText={setEmail}
        />
      </View>
      <View style={styles.field}>
        <TextInput
          placeholder="Password"
          placeholderTextColor="rgba(255,255,255,0.5)"
          style={styles.input}
          secureTextEntry
          value={password}
          onChangeText={setPassword}
        />
      </View>
      <TouchableOpacity style={styles.btn} onPress={onSignIn}>
        <Text style={styles.btnText}>{loading ? 'Signing in...' : 'Sign In'}</Text>
      </TouchableOpacity>
      {status ? <Text style={styles.status}>{status}</Text> : null}
      <TouchableOpacity style={[styles.homeBtn, { marginTop: 12 }]} onPress={goHome}>
        <Text style={styles.homeBtnText}>Go Home</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#0b0b0b', alignItems: 'center', justifyContent: 'center', padding: 24 },
  title: { color: '#fff', fontSize: 20, fontWeight: '700', marginBottom: 16 },
  field: { width: '100%', maxWidth: 420, marginBottom: 10 },
  input: { height: 44, paddingHorizontal: 12, borderRadius: 8, borderWidth: 1, borderColor: 'rgba(255,255,255,0.18)', color: '#fff' },
  btn: { marginTop: 4, backgroundColor: '#fff', paddingVertical: 12, paddingHorizontal: 16, borderRadius: 8 },
  btnText: { color: '#000', fontWeight: '700' },
  status: { marginTop: 10, color: 'rgba(255,255,255,0.85)' },
  restrictedWrap: { flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#0b0b0b' },
  restrictedText: { color: '#fff', marginBottom: 12 },
  homeBtn: { backgroundColor: '#fff', paddingVertical: 10, paddingHorizontal: 14, borderRadius: 8 },
  homeBtnText: { color: '#000', fontWeight: '700' },
});


